"use client"
import styled from "@emotion/styled"
import { HomeIcon, RedirectLinkIcon } from "ui/icons"

import { Sitemap as SitemapType } from "lib/utils"
import colors from "theme/colors"
import { CustomBreadcrumbs, LinkComponent, NewText, TitleWithLine } from "ui"

const StyledSitemapDiv = styled.div`
  margin-top: 20px;
  padding-bottom: 151px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 90px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-bottom: 190px;
  }
`

const StyledLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-wrap: wrap;
    flex-direction: row;
  }
`

const SubLinksWrapper = styled.ul`
  margin-left: 34px;
  list-style-type: none;
padding:0;
  a {
    margin-top: 10px;
  }
`

const StyledLi = styled.li``

const StyledLinksDiv = styled.div`
  margin-top: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    min-width: 250px;
    margin-right: 20px;
    margin-top: 40px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    min-width: 350px;
  }
`
const StyledText = styled.div`
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    margin-right: 10px;
    margin-left: 3px;
  }
`
const Container = styled.div`
  padding: 0 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    min-width: 350px;
    margin-right: 20px;
    margin-top: 40px;
  }
`
type Props = {
  pages: SitemapType
  excludedUrls?: string[]
}

const footer = [
  "price-lists",
  "accessibility",
  "termsclub",
  "privacy-policy",
  "terms",
]

function Sitemap({ pages, excludedUrls = [] }: Props) {
  const mainPages = pages
    .filter(
      (page) =>
        !footer.some((footerItem) => page.url.includes(footerItem)) &&
        !excludedUrls.some((excludedUrl) => page.url.includes(excludedUrl)),
    )
    .map((page) => ({
      ...page,
      children: page.children.filter(
        (child) =>
          !excludedUrls.some((excludedUrl) => child.url.includes(excludedUrl)),
      ),
    }))
  const footerPages = pages.filter((page) =>
    footer.some((footerItem) => page.url.includes(footerItem)),
  )
  return (
    <Container>
      <CustomBreadcrumbs
        current={{ title: "מפת אתר", url: `/` }}
        parents={[{ title: <HomeIcon />, url: "/" }]}
      />

      <StyledSitemapDiv>
        <TitleWithLine
          title="מפת אתר"
          titleColor={colors.black}
          component={"h1"}
        />
        <StyledLinksWrapper>
          {mainPages.map((page, index) => {
            return (
              <StyledLinksDiv key={index.toString()}>
                {page.children.length ? (
                  <StyledText>
                    <RedirectLinkIcon color={colors.blue} />
                    <NewText
                      component={"h2"}
                      largeDesktopFontSize={24}
                      largeDesktopLineHeight="33.6px"
                      desktopFontSize={16}
                      desktopLineHeight="22.4px"
                      mobileFontSize={24}
                      mobileLineHeight={"33.6px"}
                      color={colors.blue}
                      desktopFontWeight={500}
                    >
                      {page.title}
                    </NewText>
                  </StyledText>
                ) : (
                  <LinkComponent
                    text={page.title || ""}
                    link={page.url || ""}
                    largeDesktopFontSize={24}
                    largeDesktopLineHeight="33.6px"
                    mobileFontSize={24}
                    mobileLineHeight={"33.6px"}
                    fontSize={16}
                    desktopLineHeight="22.4px"
                    icon={<RedirectLinkIcon color={colors.blue} />}
                    fontWeight={500}
                    compType={'h2'}
                  />
                )}

                {page.children.length ? (
                  <SubLinksWrapper>
                    {page.children.map((child, ind: number) => (
                      <StyledLi key={ind.toString()}>
                        <LinkComponent
                          text={child.title || ""}
                          link={child.url || ""}
                          largeDesktopFontSize={16}
                          largeDesktopLineHeight="24px"
                          fontSize={10.67}
                          desktopLineHeight="16px"
                          mobileFontSize={16}
                          mobileLineHeight="24px"
                          icon={
                            <RedirectLinkIcon color={colors.primaryDarkBlue} />
                          }
                          fontWeight={400}
                          color={colors.gray}
                          compType={'p'}
                        /></StyledLi>
                    ))}
                  </SubLinksWrapper>
                ) : null}
              </StyledLinksDiv>
            )
          })}
          <FooterLinks>
            {footerPages.map((el) => (
              <LinkComponent
                key={el.url}
                text={el.title}
                link={el.url}
                largeDesktopFontSize={16}
                largeDesktopLineHeight="24px"
                fontSize={12}
                desktopLineHeight="18px"
                mobileFontSize={16}
                mobileLineHeight="24px"
                icon={<RedirectLinkIcon color={colors.blue} />}
                fontWeight={500}
                compType={'h2'}
              />
            ))}
          </FooterLinks>
        </StyledLinksWrapper>
      </StyledSitemapDiv>
    </Container>
  )
}

export default Sitemap
